export enum Breakpoint {
    Desktop = 1,
    TabletLandscape = 2,
    TabletPortrait = 3,
    Mobile = 4
}